import React from 'react';
import Chip from 'Chip';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Nav from '../../component/nav';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { content } = this.props;
        const { nav } = content;

        return (
            <nav className={styles.header} aria-label="主导航">
                <Chip id="20002" type="struct" title="导航" groupName="头部" content={nav}>
                    <Nav />
                </Chip>
            </nav>
        );
    }
}

export default errorBoundary(Header);
